/* Wonder Woof — yeni ürün sayfası (product.ww-yeni)
   Temanın kendi varyant seçicisi / sepet formu çalışmaya devam eder;
   bu dosya yalnızca görünümü tasarıma uyarlar. */
(function () {
  var kok = document.querySelector('.product-information--main');
  if (!kok) return;
  kok.classList.add('ww-urun');

  /* ---------- 1) Açıklamayı bölümlere ayır ---------- */
  var tpl = document.getElementById('ww-aciklama');
  var bolumler = { ozellik: [], aciklama: [], kullanim: [], materyal: [], beden: [] };
  if (tpl) {
    var kap = document.createElement('div');
    kap.innerHTML = tpl.innerHTML;
    var aktif = 'aciklama';
    var norm = function (t) { return (t || '').toLocaleLowerCase('tr').replace(/\s+/g, ' ').trim(); };
    var anahtar = function (t) {
      t = norm(t);
      if (/öne çıkan|özellikler$/.test(t) && !/teknik/.test(t)) return 'ozellik';
      if (/beden|ölç/.test(t)) return 'beden';
      if (/teknik|materyal|malzeme|bakım|temizlik|içerik/.test(t)) return 'materyal';
      if (/kullan|uyarı|dikkat/.test(t)) return 'kullanim';
      if (/ne işe yarar|açıklama|hakkında/.test(t)) return 'aciklama';
      return null;
    };
    [].slice.call(kap.children).forEach(function (el) {
      var tag = el.tagName;
      var yazi = el.textContent.trim();
      var baslikMi = /^H[1-6]$/.test(tag);
      var strong = el.querySelector && el.querySelector('strong, b');
      // yalnızca kalın yazıdan oluşan paragraf = başlık
      if (!baslikMi && tag === 'P' && strong && norm(strong.textContent) === norm(yazi)) baslikMi = true;
      if (baslikMi) {
        var k = anahtar(yazi);
        if (k) { aktif = k; if (k !== 'aciklama' && k !== 'ozellik') bolumler[k].push(el); return; }
      } else if (tag === 'P' && strong && el.firstElementChild === strong) {
        // "Temizlik: ...", "Nasıl ölçülür? ..." gibi kalın başlangıçlı paragraf
        var k2 = anahtar(strong.textContent);
        if (k2 && k2 !== 'ozellik') { bolumler[k2].push(el); return; }
      }
      bolumler[aktif].push(el);
    });
  }

  /* öne çıkan özellikler: listedeki kalın kısım ya da ilk cümle */
  var maddeler = [];
  bolumler.ozellik.forEach(function (el) {
    if (el.tagName === 'UL' || el.tagName === 'OL') {
      [].slice.call(el.querySelectorAll('li')).forEach(function (li) {
        var s = li.querySelector('strong, b');
        var t = s ? s.textContent : li.textContent.split(/[.:]/)[0];
        t = t.replace(/[:：]\s*$/, '').trim();
        if (t) maddeler.push(t);
      });
    }
  });
  maddeler = maddeler.slice(0, 5);

  /* beden tablosu: beden -> ölçü */
  var bedenOlcu = {}, olcuAdi = '';
  var tablo = null;
  bolumler.beden.forEach(function (el) { if (!tablo) tablo = el.tagName === 'TABLE' ? el : el.querySelector && el.querySelector('table'); });
  if (!tablo && tpl) { var tt = document.createElement('div'); tt.innerHTML = tpl.innerHTML; tablo = tt.querySelector('table'); }
  if (tablo) {
    var th = tablo.querySelectorAll('thead th, tr:first-child th');
    if (th.length > 1) olcuAdi = th[1].textContent.replace(/\([^)]*\)/g, '').replace(/çevresi|uzunluğu/i, '').replace(/\s+/g, ' ').trim();
    [].slice.call(tablo.querySelectorAll('tbody tr, tr')).forEach(function (tr) {
      var td = tr.querySelectorAll('td');
      if (td.length > 1) bedenOlcu[td[0].textContent.trim().toUpperCase()] = td[1].textContent.trim();
    });
  }

  /* ---------- 2) Beden rehberi penceresi ---------- */
  var dlg = null;
  if (bolumler.beden.length) {
    dlg = document.createElement('dialog');
    dlg.className = 'ww-rehber';
    dlg.innerHTML = '<div class="ww-rehber__ic"><div class="ww-rehber__bas"><strong>Beden rehberi</strong><button type="button" aria-label="Kapat">×</button></div><div class="ww-rehber__govde"></div></div>';
    var govde = dlg.querySelector('.ww-rehber__govde');
    bolumler.beden.forEach(function (el) { if (!/^H[1-6]$/.test(el.tagName)) govde.appendChild(el.cloneNode(true)); });
    dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    document.body.appendChild(dlg);
  }

  /* ---------- 3) Akordeonlar ---------- */
  var detay = document.querySelector('[data-ww-detay]');
  if (detay) {
    var ikonOk = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    var ikonTik = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#2F8F6E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg>';
    var ekle = function (baslik, dugumler, acik, html) {
      if (!html && (!dugumler || !dugumler.length)) return;
      var d = document.createElement('details');
      d.className = 'ww-ak';
      if (acik) d.open = true;
      d.innerHTML = '<summary><span>' + baslik + '</span>' + ikonOk + '</summary><div class="ww-ak__ic"></div>';
      var ic = d.querySelector('.ww-ak__ic');
      if (html) ic.innerHTML = html; else dugumler.forEach(function (el) { ic.appendChild(el); });
      detay.appendChild(d);
    };
    if (maddeler.length) {
      ekle('Öne çıkan özellikler', null, true, '<ul class="ww-tik">' + maddeler.map(function (m) { return '<li>' + ikonTik + '<span>' + m.replace(/</g, '&lt;') + '</span></li>'; }).join('') + '</ul>');
    }
    ekle('Açıklama', bolumler.aciklama.filter(function (el) { return el.textContent.trim(); }));
    ekle('Kullanım', bolumler.kullanim);
    ekle('Materyal & Bakım', bolumler.materyal);
    var kargo = document.getElementById('ww-kargo');
    if (kargo) ekle('Kargo & İade', null, false, kargo.innerHTML);
  }

  /* ---------- 4) Varyant seçici görünümü ---------- */
  var secenekAdi = function (fs) {
    var t = fs.querySelector('.variant-option__label-text');
    return t ? t.textContent.replace(':', '').trim() : '';
  };
  var uygula = function () {
    var picker = kok.querySelector('variant-picker');
    if (!picker) return;
    [].slice.call(picker.querySelectorAll('.variant-option--fieldset')).forEach(function (fs) {
      if (fs.dataset.ww === '1') return;
      fs.dataset.ww = '1';
      var ad = secenekAdi(fs);
      var adK = ad.toLocaleLowerCase('tr');
      var lbl = fs.querySelector('.variant-option__label-text');
      var trAd = /renk|color|colour/.test(adK) ? 'Renk' : (/beden|size|boyut/.test(adK) ? 'Beden' : ad);
      if (lbl) lbl.textContent = trAd.toLocaleUpperCase('tr');
      var inputs = [].slice.call(fs.querySelectorAll('input[type=radio]'));

      var bedenMi = /beden|size|boyut/.test(adK);
      if (/renk|color|colour/.test(adK) || bedenMi) {
        fs.classList.add(bedenMi ? 'ww-beden-sec' : 'ww-renk-sec');
        var sel = document.createElement('select');
        sel.className = 'ww-select';
        sel.setAttribute('aria-label', trAd);
        inputs.forEach(function (inp) {
          var o = document.createElement('option');
          o.value = inp.value;
          var olc = bedenMi ? bedenOlcu[inp.value.toUpperCase()] : '';
          var gor = inp.value.charAt(0).toLocaleUpperCase('tr') + inp.value.slice(1);
          o.textContent = gor + (olc ? ' · ' + (olcuAdi ? olcuAdi + ' ' : '') + olc : '') + (inp.dataset.optionAvailable === 'false' ? ' — Tükendi' : '');
          if (inp.checked) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function (e) {
          // Temanın varyant seçicisi bu listeyi kendi seçimi sanmasın:
          // olay variant-picker'a ulaşmadan durdurulur, seçim gerçek radyo ile yapılır.
          e.stopPropagation();
          var alan = sel.closest('fieldset') || fs;
          var hedef = [].slice.call(alan.querySelectorAll('input[type=radio]')).filter(function (i) { return i.value === sel.value; })[0];
          if (hedef && !hedef.checked) { hedef.click(); }
        });
        fs.appendChild(sel);
        if (bedenMi && dlg) {
          var bas = fs.querySelector('.variant-option__label');
          if (bas && !bas.querySelector('.ww-rehber-link')) {
            var a = document.createElement('button');
            a.type = 'button';
            a.className = 'ww-rehber-link';
            a.textContent = 'Beden rehberi';
            a.addEventListener('click', function () { dlg.showModal(); });
            bas.appendChild(a);
          }
        }
      }
    });
  };

  /* ---------- 5) İndirim etiketi ---------- */
  var sayi = function (t) {
    t = (t || '').replace(/[^\d.,]/g, '');
    if (!t) return 0;
    // 4,550.00 veya 4.550,00
    if (/,\d{2}$/.test(t)) t = t.replace(/\./g, '').replace(',', '.'); else t = t.replace(/,/g, '');
    return parseFloat(t) || 0;
  };
  var indirim = function () {
    var pr = kok.querySelector('.product-price');
    if (!pr) return;
    var eski = pr.querySelector('.ww-indirim');
    var fiyatEl = pr.querySelector('.price__sale .price--sale, .price__regular .price');
    var karsi = pr.querySelector('.compare-at-price');
    var f = fiyatEl ? sayi(fiyatEl.textContent) : 0;
    var k = karsi ? sayi(karsi.textContent) : 0;
    if (k > f && f > 0) {
      var yuzde = Math.round((k - f) / k * 100);
      if (!eski) { eski = document.createElement('span'); eski.className = 'ww-indirim'; (pr.querySelector('.price-container') || pr).appendChild(eski); }
      eski.textContent = '%' + yuzde + ' indirim';
    } else if (eski) eski.remove();
  };

  var calis = function () { uygula(); indirim(); };
  calis();
  var bekleyen = false;
  new MutationObserver(function () {
    if (bekleyen) return;
    bekleyen = true;
    requestAnimationFrame(function () { bekleyen = false; calis(); });
  }).observe(kok, { childList: true, subtree: true });
})();
